import { render, staticRenderFns } from "./foreKp.vue?vue&type=template&id=6a95cd61&scoped=true&"
import script from "./foreKp.vue?vue&type=script&lang=js&"
export * from "./foreKp.vue?vue&type=script&lang=js&"
import style0 from "./foreKp.vue?vue&type=style&index=0&id=6a95cd61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95cd61",
  null
  
)

export default component.exports